import * as React from 'react';
import Toggle from 'react-toggle';
import { Input, Dropdown, Button, Radio, Form } from 'semantic-ui-react';

export interface ListOptions {
    key?: string | number;
    value: string | number;
    text: string;
}

export module Config {

    class OptionProps {
        id: string;
        className ?: string;
        optional ?: boolean;
        group ?: string;
        checked ?: boolean;
        caption: string;
        valid ?: boolean;
        hint ?: string | boolean;
        charLength ?: number;
        options ?: ListOptions[];
        unit ?: string;
        readOnly ?: boolean;
        hide ?: any;
        disabled?: boolean;
        fieldWidth?: number;

        onToggle ?: (state: boolean) => void;
    }

    class OptionState {
    }

    class PaneState {
    }

    class PaneProps {
    }

    /*
    class CheckOptionState extends OptionState {
        checked ?: boolean;
    }*/

    // class CheckOptionProps extends OptionProps {
    //     toggle ?: boolean;
    //     checked ?: boolean;
    //     defaultValue ?: boolean;
    // }

    class Renderers {
        static getHintNode(hint: string | boolean | undefined, id ?: string): React.ReactNode {
            if (hint === false)
                return undefined;
            if (hint === true && id !== undefined)
                return this.getHintNode(id);
            else return hint ? <span className="hint">{hint}</span> : null;
        }

        static checkbox(id: string, checked: boolean, toggle: boolean, readOnly: boolean, onChange: React.FormEventHandler<HTMLInputElement>) {
            return toggle
                ? <Toggle id={id} checked={checked} disabled={readOnly} onChange={onChange}/>
                : <Input type="checkbox" id={id} checked={checked} onChange={onChange}/>;
        }
    }

    class Helpers {
        static makeIdentifier(value: string): string {
            return value.replace(/[^a-zA-Z0-9_\-]+/g, '-').toLowerCase();
        }

        static getId(id: string | undefined, hint: string | undefined): string | undefined {
            return id
                ? id
                : hint
                    ? this.makeIdentifier(hint)
                    : undefined;
        }
    }

    export class Pane extends React.Component<PaneProps, PaneState> {
        render() {
            return (
                <div className="config-pane">
                    {this.props.children}
                </div>
            );
        }
    }

    export interface WrapOptions {
        debug ?: boolean;
        className ?: string;
        useToggle ?: boolean;
        gutter ?: boolean;
        defaultChecked ?: boolean;
        forceOptional ?: boolean;
        validator ?: (value: any, props?: any) => boolean;
    }

    export interface WrapOptionState {
        value ?: any;
        readOnly?: boolean;
    }

    export const wrapOption = ({
                       debug = false,
                       className = 'default',
                       gutter = true,
                       useToggle = true,
                       forceOptional = false,
                       validator = undefined
            }: WrapOptions = {}) =>
        <TOriginalProps extends {}>(Component ?: (React.ComponentClass<TOriginalProps & OptionProps> | React.StatelessComponent<TOriginalProps & OptionProps>)) => {
            type ResultProps = TOriginalProps & OptionProps;
            return class WrapOption extends React.Component<ResultProps, WrapOptionState>  {

                protected static hr(): React.ReactNode {
                    // only output an HR if we have an input control on the right
                    return Component
                        ? <span className="hr"><hr/></span>
                        : null;
                }

                componentWillMount() {
                    this.setState({
                    //    value: this.props.defaultValue,
                        readOnly: this.props.readOnly
                    });
                }

                render() {
                    // figure out the validity of the value
                    const anyprops = this.props as any;
                    let value = anyprops.defaultValue;
                    const validity = (this.props.valid !== undefined)
                        ? this.props.valid
                        : (validator !== undefined && value !== undefined)
                            ? validator(value, this.props)
                            : undefined
                        ;
                    const validityClass = (validity !== undefined)
                        ? 'validated ' + (validity ? 'valid' : 'invalid')
                        : '';
                    const hide = this.props.hide;
                    if (this.props.id === '.') {
                        return (
                            <RenderedConfigItem hide={hide} id={this.props.id}>
                                <div className={`config-option config-${className} ${this.props.className} ${validityClass}`}>
                                    {this.props.caption && (gutter
                                            ? <span className="gutter">
                                        <label htmlFor={this.props.id}>{this.props.caption}</label>
                                            {this.optional()}
                                        </span>
                                            : <label htmlFor={this.props.id}>{this.props.caption}</label>
                                    )}
                                    {/*{Renderers.getHintNode(this.props.hint, this.props.id)}*/}
                                    {Component ? <Component {...this.props} {...this.state} /> : null}
                                    {(validity !== undefined && !validity && !this.props.disabled) ? null : null}
                                </div>
                            </RenderedConfigItem>
                        );
                    } else {
                        return (
                            <RenderedConfigItem hide={hide} id={this.props.id}>
                                <div className={`config-option config-${className} ${this.props.className} ${validityClass}`}>
                                    {this.props.caption && (gutter
                                            ? <span className="gutter">
                                        <label htmlFor={this.props.id}>{this.props.caption}</label>
                                            {this.optional()}
                                        </span>
                                            : <label htmlFor={this.props.id}>{this.props.caption}</label>
                                    )}
                                    {Renderers.getHintNode(this.props.hint, this.props.id)}
                                    {Component ? <Component {...this.props} {...this.state} /> : null}
                                    {(validity !== undefined && !validity && !this.props.disabled) ? null : null}
                                </div>
                            </RenderedConfigItem>
                        );
                    }
                }

                protected checkbox(): React.ReactNode {
                    return Renderers.checkbox(
                        this.props.id,
                        !!(this.props && this.props.checked),
                        useToggle || true,
                        !!(this.props ? this.props.disabled : (this.state.readOnly || false)),
                        (ev: React.ChangeEvent<HTMLInputElement>) => { if (this.props.onToggle) this.props.onToggle(ev.target.checked); }
                        );
                }

                protected radio(): React.ReactNode {
                    return (
                        <input
                            type="radio"
                            id={this.props.id}
                            name={this.props.group}
                            checked={this.props.checked || false}
                            disabled={this.state.readOnly}
                            onChange={ev => { if (this.props.onToggle) this.props.onToggle(ev.target.checked); }}
                        />
                    );
                }

                protected unit(): React.ReactNode {
                    return this.props.unit ? <span className="unit">{this.props.unit}</span> : null;
                }

                protected optional() {
                    return !this.props.optional && !forceOptional
                        ? <span className="always">&nbsp;</span>
                        : this.props.group
                            ? <div>{this.radio()} {WrapOption.hr()}</div>
                            : <div>{this.checkbox()} {WrapOption.hr()}</div>;
                }
            };
        };

    const SectionContext = React.createContext< (id: string|undefined, hidden: boolean) => void >( (id, hidden) => null );

    interface ItemProps {
        id?: string;
        hide: boolean;
        children: any;
    }

    // component indicates to parent Section if we rendered or not
    const RenderedConfigItem = (props: ItemProps) => {
        let { id, hide, children } = props;
        return (
            <SectionContext.Consumer>{parent => {
                parent(id, !hide);  // notify parent section we are rendering content
                return hide ? false : (
                    <React.Fragment>
                        {children}
                    </React.Fragment>
                );
            }}</SectionContext.Consumer>
        );
    };
    
    class SectionState {
        visible: boolean;   // visibility of this section (forces visibility)
        visibility: {};     // visibility of children
    }

    class SectionProps {
        id ?: string;
        title: string;
    }

    export class Section extends React.Component<SectionProps, SectionState> {
        constructor(props: SectionProps) {
            super(props);
            this.state = { visible: false, visibility: {} };
            this.updateChild = this.updateChild.bind(this);
        }

        getId(): string {
            return this.props.id || Helpers.makeIdentifier(this.props.title);
        }

        // return true if this section, or any child, is marked as visible
        isVisible() {
            let { visible, visibility } = this.state;
            return visible
                ? true
                : !!Object.keys(visibility).find( (v: any) => !! visibility[v]);
        }

        render() {
            const visible = this.isVisible();
            return (
                    <SectionContext.Consumer>{ parent => {
                        // todo: this causes a warning about setting state within render() but cannot be fixed without reworking Config controls
                        // if reworking is desired, I would suggest the config moved to a Data Driven  model where controls are rendered from some
                        // Json and the rendering system can therefore look ahead in the model to determine child visibility. This is a decent example:
                        // https://codesandbox.io/s/x2lq6royno
                        parent(this.props.id, visible);  // notify parent section we are rendering content
                        return (
                            <div className="config-section" id={this.getId()} style={{display: visible ? 'block' : 'none'}}>
                                <div className="config-section-header">{this.props.title}</div>
                                <div className="config-section-content">
                                    <SectionContext.Provider value={this.updateChild} >
                                        {this.props.children}
                                    </SectionContext.Provider>
                                </div>
                            </div>
                        ); }}</SectionContext.Consumer>
                );
        }

        private updateChild(id: string, hidden: boolean)  {
            // if visibility of this control changed, then update our state visibility tracking of the child
            if (this.state.visibility[id] !== hidden)
                this.setState((prev: SectionState) => ({ visibility: { ...prev.visibility, [id]: hidden }}) );
        }
    }

    class TextProps extends OptionProps {
        optional ?: boolean;
        checked ?: boolean;
        maxLength ?: number;
        defaultValue ?: string;
        charLength ?: number;
        onChange ?: (value ?: string) => void;
        placeholder ?: string;
        fieldWidth?: number;
        disabled?: boolean;
    }

    export class TextInput extends React.Component<TextProps, OptionState> {
        public static defaultProps: Partial<TextProps> = {
            className: 'text',
            checked: false
        };

        render() {
            let id = this.props.id; // Helpers.getId(this.props.id, this.props.hint);
            return (
                <Input
                    type="text"
                    className="text"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.props.onChange ? this.props.onChange(e.target.value) : false}
                    id={id}
                    name={id}
                    style={{width: this.props.fieldWidth + 'px'}}
                    maxLength={this.props.maxLength}
                    value={this.props.defaultValue}
                    // size={'medium'}
                    disabled={this.props.disabled ? this.props.disabled : this.props.readOnly}
                    placeholder={this.props.placeholder}
                />
            );
        }
    }

    class NumericProps extends OptionProps {
        defaultValue ?: number;
        minimum?: number;
        maximum?: number;
        onChange ?: (value ?: number) => void;
    }

    export class NumericBox extends React.Component<NumericProps, OptionState> {
        public static defaultProps: Partial<NumericProps> = {};

        render() {
            let id = this.props.id;
            return (
                <React.Fragment>
                    <Input
                        key="editor"
                        type="text"
                        className="numeric"
                        id={id + '_value'}
                        name={id + '_value'}
                        size={'small'}
                        value={this.props.defaultValue}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.props.onChange ? this.props.onChange(Number(e.target.value)) : false}
                        disabled={!this.props || this.props.defaultValue === undefined}
                    />
                    {this.props.unit ? <span key="unit" className="unit">{this.props.unit}</span> : null}
                </React.Fragment>
            );
        }
    }

    export class NumericBox2 extends React.Component<NumericProps, OptionState> {
        public static defaultProps: Partial<NumericProps> = {
            disabled:  false
        };

        render() {
            let id = this.props.id;
            return (
                <React.Fragment>
                    <Input
                        key="editor"
                        type="text"
                        className="numeric"
                        id={id + '_value'}
                        name={id + '_value'}
                        size={'small'}
                        value={this.props.defaultValue}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.props.onChange ? this.props.onChange(Number(e.target.value)) : false}
                        disabled={!this.props || this.props.disabled}
                    />
                    {this.props.unit ? <span key="unit" className="unit">{this.props.unit}</span> : null}
                </React.Fragment>
            );
        }
    }

    export class NumericButtonsGroup extends React.Component<NumericProps, OptionState> {
        public static defaultProps: Partial<NumericProps> = {};

        renderButtons() {
            let { id, defaultValue, minimum, maximum } = this.props;
            if (minimum === undefined || maximum === undefined || minimum > maximum)
                return null;
            let buttons = [];
            for (let i = minimum; i <= maximum; i++) {
                buttons.push((
                    <Button
                        key={'v' + i}
                        className="numericButton"
                        id={id + '_value'}
                        name={id + '_value'}
                        toggle
                        active={defaultValue === i}
                        size="mini"
                        onClick={() => this.props.onChange ? this.props.onChange(i) : false}
                        disabled={defaultValue === undefined}
                    >
                        {i}
                    </Button>
                ));
            }
            return <div className="numericButtons">{buttons}</div>;
        }

        render() {
            let { unit, minimum, maximum } = this.props;
            if (minimum === undefined || maximum === undefined || minimum > maximum)
                return null;
            return (
                <React.Fragment>
                    {this.renderButtons()}
                    {unit ? <span key="unit" className="unit">{unit}</span> : null}
                </React.Fragment>
            );
        }
    }

    export class NumericButtonsGroup2 extends React.Component<NumericProps, OptionState> {
        public static defaultProps: Partial<NumericProps> = {
            disabled:  false
        };

        renderButtons() {
            let { id, defaultValue, minimum, maximum } = this.props;
            if (minimum === undefined || maximum === undefined || minimum > maximum)
                return null;
            let buttons = [];
            for (let i = minimum; i <= maximum; i++) {
                buttons.push((
                    <Button
                        key={'v' + i}
                        className="numericButton"
                        id={id + '_value'}
                        name={id + '_value'}
                        toggle
                        active={defaultValue === i}
                        size="mini"
                        onClick={() => this.props.onChange ? this.props.onChange(i) : false}
                        disabled={!this.props || this.props.disabled}
                    >
                        {i}
                    </Button>
                ));
            }
            return <div className="numericButtons">{buttons}</div>;
        }

        render() {
            let { unit, minimum, maximum } = this.props;
            if (minimum === undefined || maximum === undefined || minimum > maximum)
                return null;
            return (
                <React.Fragment>
                    {this.renderButtons()}
                    {unit ? <span key="unit" className="unit">{unit}</span> : null}
                </React.Fragment>
            );
        }
    }

    class ListProps extends OptionProps {
      defaultValue ?: any;
      onChange ?: (value ?: boolean|string|number) => void;
    }

    export class ListSelector extends React.Component<ListProps, OptionState> {
        public static defaultProps: Partial<ListProps> = {

        };

        render() {
            return (
                <Dropdown
                    className="dropDown"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>,  data: any) => {return (this.props.onChange && data.value !== undefined) ? this.props.onChange(data.value)  : false; }}
                    value={this.props.defaultValue}
                    selection
                    options={this.props.options}
                    // disabled={this.props.readOnly}
                    disabled={this.props.disabled ? this.props.disabled : this.props.readOnly}
                />
            );
        }
    }

    export class RadioListSelector extends React.Component<ListProps, OptionState> {
        public static defaultProps: Partial<ListProps> = {
        };

        render() {
            const { id, options, defaultValue, className, onChange } = this.props;
            return (
                <Form>
                  { Array.isArray(options) && options.map( (o, idx) =>
                      <Form.Group key={o.key || idx}>
                          <Radio
                            className={className}
                            name={id}
                            label={o.text}
                            value={o.value}
                            checked={defaultValue === o.value}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>,  { value } ) => (onChange && value !== undefined) ? onChange(value)  : false}
                          />
                      </Form.Group>
                    )}
                </Form>
            );
        }
    }

    const urlPattern = new RegExp('^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3})|' + // OR ip (v4) address
        // (\[(?:[:0-9A-Fa-f]+)\])|(?:[:0-9A-Fa-f]+) - *example*
        '(\\[(?:[:0-9A-Fa-f]+)\\]))' + // OR ip (v6) address *brackets mandatory*
        // '((\\[(?:[:0-9A-Fa-f]+)\\])|(?:[:0-9A-Fa-f]+)))' + // OR ip (v6) address *optional brackets*
        // '((([0-9a-fA-F]){1,4})\\:){7}([0-9a-fA-F]){1,4})' + // OR ip (v6) address
        '(\\:\\d+)?(\\/[^\\/]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',     'i'); // fragment locator

    // const urlPatternIPv6 = new RegExp('^(https?:\\/\\/)?' + // protocol
    //     '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
    //     '((\\d{1,3}\\.){3}\\d{1,3})|' + // OR ipv4 address
    //     '((\\[*([0-9a-fA-F]){1,4})\\:){7}([0-9a-fA-F]){1,4}\\]*)' + // ipv6 (with or without square brackets)
    //     '(\\:\\d+)?(\\/[^\\/]*)*' + // port and path
    //     '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    //     '(\\#[-a-z\\d_]*)?$',         'i'); // fragment locator

    function ValidateURL(str: string): boolean {
        return (str.length > 0)
            ? urlPattern.test(str)
            : true;
    }
    // function ValidateURLv6NotWorking(str: string): boolean {
    //     return (str.length > 0)
    //         ? urlPatternIPv6.test(str)
    //         : true;
    // }
    function ValidateURLIPv6(str: string): boolean {
        let url;
        try {
            url = new URL(str);
        } catch (e) {
            // do nothing
        }

        if (url) {
            return true;
        } else {
            return false;
        }
    }

    // a name can contain alpha-numeric characters but no spaces
    // const namePattern = new RegExp('^[A-Za-z0-9_\ \'\$\\-\[\\]\(\)]*$');
    function ValidateName(str: string): boolean {
        return true;        // for now, we are leaving it wide open
        /*return (str.length > 0)
            ? namePattern.test(str)
            : true;*/
    }

    const validateDurationPattern = new RegExp('^[0-9]{1,2}:[0-9]{1,2}:[0-9]{1,2}$');
    function ValidateDuration(str: string): boolean {
        return validateDurationPattern.test(str);
    }

    function ValidateMinMax(value: number, props: NumericProps) {
        if (!props || value === undefined || props.disabled) return true;    // no props will not show invalid, but will be disabled
        if (props.minimum !== undefined && value < props.minimum)
            return false;
        if (props.maximum !== undefined && value > props.maximum)
            return false;
        return true;
    }

    // standard config controls
    export const Numeric = wrapOption({className: 'numeric2', gutter: false, validator: ValidateMinMax})(NumericBox);
    export const Numeric2 = wrapOption({className: 'numeric2', gutter: false, validator: ValidateMinMax})(NumericBox2);
    export const NumericButtons = wrapOption({className: 'numeric2', gutter: false, validator: ValidateMinMax})(NumericButtonsGroup);
    export const NumericButtons2 = wrapOption({className: 'numeric2', gutter: false, validator: ValidateMinMax})(NumericButtonsGroup2);
    export const Checkbox = wrapOption({className: 'check', forceOptional: true})();

    export const Text = wrapOption({className: 'text'})(TextInput);
    export const LongText = wrapOption({className: 'text', gutter: false})(TextInput);
    export const List = wrapOption({className: 'text', gutter: false})(ListSelector);
    export const RadioList = wrapOption({className: 'radiolist', gutter: false})(RadioListSelector);

    // specific config editors
    export const Url = wrapOption({className: 'text url', gutter: false, validator: ValidateURL})(TextInput);
    export const UrlIPv6 = wrapOption({className: 'text url', gutter: false, validator: ValidateURLIPv6})(TextInput);
    export const Name = wrapOption({className: 'text url', gutter: false, validator: ValidateName})(TextInput);
    export const TimeDuration = wrapOption({className: 'text url', gutter: false, validator: ValidateDuration})(TextInput);
}

export default Config;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/config.tsx